<template>
  <el-card
    v-show="visible"
    ref="card"
    class="newshipv2"
    :body-style="{ padding: '10px' }"
    :style="style"
  >
    <div slot="header" class="clearfix newshipv2-header">
      <span style="font-size: 16px"
        >船舶信息
        <el-tooltip
          class="item"
          effect="dark"
          content="来源网站船舶查询，每天凌晨更新"
          placement="top"
          :tabindex="point.zIndex + 1"
        >
          <i class="el-icon-warning-outline newshipv2-icon"></i>
        </el-tooltip>
      </span>

      <el-button
        type="text"
        icon="el-icon-close"
        style="float: right"
        @click="$emit('update:visible', false)"
      />
    </div>

    <el-row :gutter="10" class="match-line">
      <el-col :span="8">
        <el-input
          v-model="searchcontent"
          placeholder="请输入查询内容"
          style="width: 100%"
          size="mini"
          clearable
        />
      </el-col>
      <el-col :span="8">
        <el-radio-group v-model="ismatched">
          <el-radio :label="0" :disabled="matchdisabled">默认</el-radio>
          <el-radio :label="1" :disabled="matchdisabled">匹配</el-radio>
          <el-radio :label="2" :disabled="matchdisabled">未匹配</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="7" style="text-align: right">
        <el-popover
          ref="tag"
          placement="bottom"
          trigger="click"
          popper-class="newshipv2-tag-popover"
          :visible-arrow="false"
        >
          <new-ship-v-2-tag
            :taglist="taglist"
            :loading="downloading"
            @removeTag="removeTag"
            @downloadtags="downloadtags"
          />
        </el-popover>

        <i
          v-popover:tag
          class="el-icon-collection-tag setting-btn"
          title="标记"
          style="margin-right: 15px"
          :class="{ 'taglist-h': taglist.length }"
        ></i>

        <el-popover
          placement="bottom"
          trigger="click"
          popper-class="matchrule-popover"
          @hide="onmatchstatehide"
        >
          <el-card
            shadow="never"
            :body-style="{ padding: '5px 15px' }"
            style="border: none"
          >
            <el-divider content-position="left">匹配条件</el-divider>
            <el-checkbox-group v-model="matchrules0" class="checkgroups">
              <el-checkbox label="mmsi"> MMSI </el-checkbox>
              <el-checkbox label="imo"> IMO </el-checkbox>
              <el-checkbox label="nameEn"> 船名 </el-checkbox>
            </el-checkbox-group>
            <el-divider content-position="left"> 过滤条件 </el-divider>
            <el-form size="mini">
              <el-form-item>
                <div slot="label">
                  最后更新时间
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      <p>w:周</p>
                      <p>d:天</p>
                      <p>M:月</p>
                      <p>y:年</p>
                      <p>h:小时</p>
                      <p>m:分钟</p>
                      <p>s:秒</p>
                      <p>ms:毫秒</p>
                    </div>
                    <i class="el-icon-warning-outline newshipv2-icon"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="lastupdatetime" placeholder="最后更新时间" />
              </el-form-item>
            </el-form>
          </el-card>

          <i
            slot="reference"
            class="el-icon-setting setting-btn"
            title="设置匹配规则"
          ></i>
        </el-popover>
      </el-col>
    </el-row>

    <el-table
      v-loading="isloading"
      :data="newshipv2list"
      max-height="300px"
      :row-class-name="handleRowClassName"
    >
      <el-table-column prop="mmsi" label="MMSI" width="120">
        <div slot-scope="scope">
          <div>{{ scope.row.mmsi }}</div>
          <div
            v-if="scope.row.mmsi2"
            class="basicship-info"
            title="基础船舶对应mmsi"
          >
            {{ scope.row.mmsi2 }}
          </div>
        </div>
      </el-table-column>

      <el-table-column prop="nameEn" label="船名" width="160">
        <div slot-scope="scope">
          <div>{{ scope.row.nameEn }}</div>
          <div
            v-if="scope.row.nameEn2"
            class="basicship-info"
            title="基础船舶对应船名"
          >
            {{ scope.row.nameEn2 }}
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="imo" label="IMO" width="120">
        <div slot-scope="scope">
          <div>{{ scope.row.imo }}</div>
          <div
            v-if="scope.row.imo2"
            class="basicship-info"
            title="基础船舶对应imo"
          >
            {{ scope.row.imo2 }}
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="callSign" label="呼号" width="150" />

      <el-table-column prop="flagName" label="船旗" width="150" />

      <el-table-column
        prop="shipType"
        label="船舶类型"
        width="150"
        show-overflow-tooltip
      />

      <el-table-column prop="lastUpdateTime" label="最后更新时间" width="150">
        <div slot-scope="scope">
          {{ scope.row.lastUpdateTime | dateformat }}
        </div>
      </el-table-column>

      <el-table-column
        prop="length"
        label="船长（米）"
        width="100"
        align="right"
      >
        <div slot-scope="scope" class="newshipv2-num">
          {{ scope.row.length ? scope.row.length / 10 : '' }}
        </div>
      </el-table-column>

      <el-table-column
        prop="breadth"
        label="船宽（米）"
        width="100"
        align="right"
      >
        <div slot-scope="scope" class="newshipv2-num">
          {{ scope.row.breadth ? scope.row.breadth / 10 : '' }}
        </div>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间" width="150" />

      <el-table-column prop="updateTime" label="更新时间" width="150" />

      <el-table-column
        prop="updateCount"
        label="更新次数"
        align="right"
        width="100"
      >
        <div slot-scope="scope" class="newshipv2-num">
          {{ scope.row.updateCount }}
        </div>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="80" align="center">
        <div slot-scope="scope" style="text-align: center; width: 100%">
          <el-button
            v-if="!tags.includes(scope.row.vesselId)"
            type="text"
            size="mini"
            @click="appendTags([scope.row])"
          >
            标记
          </el-button>
          <el-button
            v-else
            type="text"
            size="mini"
            class="danger-button"
            @click="removeTag(scope.row)"
          >
            取消标记
          </el-button>
        </div>
      </el-table-column>
    </el-table>
    <el-pagination
      class="newshipv2-pagination"
      :disabled="isloading"
      background
      layout="total,prev,pager,next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="pageNum"
      @current-change="loadships"
    />
  </el-card>
</template>

<script>
import request from '@/mixins/request'
import NewShipV2Tag from './NewShipV2Tag.vue'
import { nextIndex } from './utils'
import { debounce } from 'lodash'

import dayjs from 'dayjs'

export default {
  components: {
    NewShipV2Tag,
  },

  filters: {
    dateformat(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
  },
  mixins: [request],

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      newshipv2list: [],
      searchcontent: '',

      isloading: false,

      ismatched: 2,

      pageNum: 1,
      pageSize: 20,
      total: 0,

      index: 0,

      matchrules0: [],

      lastupdatetime: '',

      taglist: [],

      downloading: false,

      graping: false,

      point: {
        x: 400,
        y: 200,
        x1: 400,
        y1: 200,
        zIndex: nextIndex(),
      },
    }
  },

  computed: {
    matchrules: {
      get() {
        return this.$store.state.app.matchrules
      },

      set(value) {
        this.$store.commit('UPDATE_MATCHRULES', value || [])
      },
    },

    matchdisabled() {
      return this.matchrules.length === 0
    },

    tags() {
      return this.taglist.map(it => it.vesselId)
    },

    style() {
      return {
        left: (this.graping ? this.point.x1 : this.point.x) + 'px',
        top: (this.graping ? this.point.y1 : this.point.y) + 'px',
        transition: this.graping ? 'none' : 'left .5s, top .5s',
        'z-index': this.point.zIndex,
      }
    },
  },

  watch: {
    searchcontent() {
      this.$nextTick(() => {
        this.pageNum = 1
        this.loadships2()
      })
    },

    ismatched() {
      this.$nextTick(() => {
        this.pageNum = 1
        this.loadships2()
      })
    },

    matchrules() {
      this.$nextTick(() => {
        this.pageNum = 1
        this.loadships2()
      })
    },

    visible(val) {
      if (val) {
        document.body.appendChild(this.$el)
      }
    },
  },

  mounted() {
    this.matchrules0 = [...(this.matchrules || [])]

    this.loadships2 = debounce(this.loadships, 500)
    this.loadships()

    const header = this.$refs.card.$el.querySelector('.el-card__header')
    header.addEventListener('mousedown', this.onheaderdown)
    this.$on('destroy', () =>
      header.removeEventListener('mousedown', this.onheaderdown)
    )
  },

  created() {
    const point = {
      x: 0,
      y: 0,
    }

    const onheadermove = event => {
      if (this.graping) {
        this.point.x1 = this.point.x + (event.pageX - point.x)
        this.point.y1 = this.point.y + (event.pageY - point.y)
      }
    }

    const onheaderup = () => {
      this.graping = false
      this.point.x = Math.min(
        Math.max(10, this.point.x1),
        window.innerWidth - 80
      )
      this.point.y = Math.min(
        Math.max(10, this.point.y1),
        window.innerHeight - 80
      )
      document.removeEventListener('mousemove', onheadermove)
      document.removeEventListener('mouseup', onheaderup)
    }

    this.onheaderdown = event => {
      this.graping = true
      point.x = event.pageX
      point.y = event.pageY
      this.point.zIndex = nextIndex()

      document.addEventListener('mousemove', onheadermove)
      document.addEventListener('mouseup', onheaderup)
    }
  },

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  beforeDestroy() {
    this.$emit('destroy')
  },

  methods: {
    handleRowClassName(scope) {
      const row = scope.row

      let classname = ''

      if (row.id) {
        classname += ' is-matched'
      }

      if (this.taglist.findIndex(it => it.vesselId === row.vesselId) !== -1) {
        classname += ' is-tag'
      }

      return classname
    },

    async loadships() {
      this.isloading = true
      const index = ++this.index

      try {
        const resp = await this.$api.get(
          '/schedules/baseVessel/querynewshipv2',
          {
            params: {
              content: this.searchcontent,
              num: this.pageNum || 1,
              size: this.pageSize,
              matched: this.ismatched === 0 ? undefined : this.ismatched === 1,
              matchrules: this.matchrules.join(','),
            },
          }
        )

        if (index === this.index) {
          if (resp.data.status === 1) {
            this.newshipv2list = resp.data.content || []
            this.total = resp.data.total
            this.pageNum = resp.data.pageNum
          } else {
            this.$message.error(resp.data.message || '查询错误')
          }
        }
      } finally {
        if (index >= this.index) {
          this.isloading = false
        }
      }
    },

    onmatchstatehide() {
      const { matchrules0, matchrules } = this
      if (
        matchrules0.length !== matchrules.length ||
        matchrules0.find(k => !matchrules.includes(k))
      ) {
        this.matchrules = [...(this.matchrules0 || [])]
      }
    },

    appendTags(rows) {
      rows = rows || []

      if (rows.length) {
        rows.forEach(row => {
          let i = this.tags.indexOf(row.vesselId)

          if (i !== -1) {
            this.taglist.splice(i, 1)
          }
          this.taglist.push(row)
        })
      }
    },

    removeTag(row) {
      const i = this.tags.indexOf(row.vesselId)

      if (i !== -1) {
        this.taglist.splice(i, 1)
      }
    },

    async downloadtags() {
      this.downloading = true
      try {
        const tags = this.tags.join(',')
        const resp = await this.$api.get(
          '/schedules/baseVessel/downloadtagnewshipv2',
          {
            params: {
              tags: tags,
              matched: this.ismatched === 0 ? undefined : this.ismatched === 1,
              matchrules: this.matchrules.join(','),
            },
            responseType: 'blob',
          }
        )

        let contentDisposition = resp.headers['content-disposition']
        if (contentDisposition) {
          let url = window.URL.createObjectURL(resp.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          let fileName = contentDisposition.split('filename=')
          link.setAttribute('download', fileName[1])
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        } else {
          this.$message.error('暂无数据')
        }
      } finally {
        this.downloading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.newshipv2 {
  width: 1100px;
  position: fixed;

  top: 20%;
  left: 20%;

  z-index: 2001;

  .newshipv2-header {
    cursor: all-scroll;
    user-select: none;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .newshipv2-icon {
    color: #e6a23c;
  }

  .newshipv2-pagination {
    text-align: right;
    margin: 10px 0;
  }

  .newshipv2-num {
    font-weight: bold;
    text-align: right;
    width: 80%;
  }

  .basicship-info {
    color: rgb(206, 206, 206);
  }

  ::v-deep tr.is-matched {
    background: rgb(248, 240, 240);

    &:hover > td {
      background: none;
    }
  }

  ::v-deep tr.is-tag {
    & > td:first-child {
      border-left: 2px solid #ffa0a0;
    }
  }

  .taglist-h {
    color: #ffa0a0;
  }

  .match-line {
    margin: 20px 0;
    display: flex;
    align-items: center;
  }

  .setting-btn {
    cursor: pointer;
    font-size: 20px;

    &:hover {
      opacity: 0.9;
    }
  }

  .danger-button {
    &:not(.is-disabled) {
      color: #f56c6c;
    }
  }
}
</style>

<style lang="scss">
.matchrule-popover {
  min-width: auto;
  max-height: inherit;

  .checkgroups {
    // display: flex;
    // flex-direction: row;

    // &>.el-checkbox {
    //     // margin: 8px 10px 8px 0;
    // }
  }
}

.newshipv2-tag-popover {
  width: 550px;
  // height: 300px;
  max-height: none;
}
</style>
